import {useAppDispatch, useAppSelector} from '../../../../redux/hooks';
import {RootState} from '../../../../redux/store';
import {TextEditor} from '../../../../Atoms/TextEditor';
import {
    addNewNote,
    changeNote,
    removeNote
} from '../../../../redux/slices/character/characterSlice';
import Input from '../../../../Atoms/Input';
import Button from '../../../../Atoms/Button';
import {DeleteOutlineSharp} from '@mui/icons-material';

export const KampagneNotes = () => {
    const notes = useAppSelector((state: RootState) => state.character.CharacterSheet.Note);
    const dispatch = useAppDispatch();

    const renderOneNote = (note: any) => {
        return (
            <div className='notes_single_note_main'>
                <div className='notes_single_note_header'>
                    <label>Überschrift</label>
                    <input className='number-input' value={note.noteHeading}
                           onChange={(e) => dispatch(changeNote({
                               noteText: note.noteText,
                               noteHeading: e.target.value,
                               noteId: note.noteId
                           }))}/>
                </div>
                <div className='notes_single_note_btn'>
                    <Button onClick={() => dispatch(removeNote(note.noteId))}><DeleteOutlineSharp/></Button>
                </div>
                <div className='notes_single_note_desc'>
                    <TextEditor className='inventory-editor' value={note.noteText}
                                onChange={(value) => dispatch(changeNote({
                                    noteHeading: note.noteHeading,
                                    noteText: value,
                                    noteId: note.noteId
                                }))}/>
                </div>
            </div>
        )
    }

    const renderAllNotes = () => {
        const html = [];
        for (const note of notes) {
            html.push(renderOneNote(note))
        }

        return html
    }

    return (
        <div className='notes_main'>
            <div className=''>
                <Button onClick={() => dispatch(addNewNote())}>Notiz hinzufügen</Button>
            </div>
            <div className='notes_container'>
                {renderAllNotes()}
            </div>
        </div>
    )
}